import { render, staticRenderFns } from "./MaterialSymbolsLightPermMediaOutline.vue?vue&type=template&id=160fc8c4"
import script from "./MaterialSymbolsLightPermMediaOutline.vue?vue&type=script&lang=js"
export * from "./MaterialSymbolsLightPermMediaOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports